import type { PermissionEnum } from '@Application/Security/Roles';
import * as React from 'react';

export type PermissionContextValue = {
	readonly permissions: readonly string[];
	readonly hasPermission: (permission: PermissionEnum) => boolean;
	readonly hasAllPermissions: (permissions: readonly PermissionEnum[]) => boolean;
	readonly hasAnyPermission: (permissions: readonly PermissionEnum[]) => boolean;
	/** `true` once the permissions fetch has resolved. A route guard must wait on this flag rather than
	 * on `hasPermission`, which is indistinguishable from "denied" before this flag flips. */
	readonly isResolved: boolean;
};

const PermissionContext = React.createContext<PermissionContextValue | null>(null);

export default PermissionContext;
